import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

/**
 * Цифра непрочитанных у пункта меню (колокольчик куратора, 11.09.2026).
 *
 * Ноль и «ещё не знаем» — ничего: пустая точка читается как «что-то новое», и к
 * ней быстро привыкают не смотреть. Больше девяти — «9+», иначе цифра не влезает
 * в кружок; читалка экрана слышит точное число.
 */
export function NavBadge({ count, className }: { count?: number; className?: string }) {
  const { t } = useTranslation();
  if (!count || count <= 0) return null;
  return (
    <span
      data-nav-badge
      role="status"
      aria-label={t('notifications.unreadCount', { count })}
      className={cn(
        'grid h-[18px] min-w-[18px] place-items-center rounded-full bg-error px-1 text-[10px] font-bold leading-none text-on-error',
        className,
      )}
    >
      {count > 9 ? '9+' : count}
    </span>
  );
}
